module.exports = __webpack_public_path__ + "img/restaurants.ed1eb001.svg";